import { ChevronDown } from "react-feather";
import styles from "../communication-chat.module.css";
import { useEffect, useState } from "react";
import moment from "moment";

const EmployeeListunread = (props) => {
  const [employeeUnreadMessages, setEmployeeUnreadMessages] = useState([]);
  const [unreadMessageCounter, setUnreadMessageCounter] = useState(0);

  useEffect(() => {
    const employees = props.unreadMessageList
      .filter((p) => p.type === "Employee" && (p.message || p.unread_no > 0))
      .sort((a, b) => {
        const unreadA = a.unread_no > 0 ? 1 : 0;
        const unreadB = b.unread_no > 0 ? 1 : 0;

        if (unreadA !== unreadB) {
          return unreadB - unreadA;
        }

        const timeA = a.message_time ? new Date(a.message_time).getTime() : 0;
        const timeB = b.message_time ? new Date(b.message_time).getTime() : 0;

        return timeB - timeA;
      });

    setEmployeeUnreadMessages(employees);

    // Count all employee unreads for the accordion header
    // Shared conversations (employee+prospect) intentionally counted here
    // Global badge handles deduplication separately
    const totalUnread = employees.reduce((acc, emp) => {
      return acc + emp.unread_no;
    }, 0);

    setUnreadMessageCounter(totalUnread);
  }, [props]);

  const formatPhoneNumber = (phoneNumber) => {
    const cleaned = ("" + phoneNumber).replace(/\D/g, "");
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return "(" + match[1] + ") " + match[2] + "-" + match[3];
    }
    return cleaned;
  };

  const getInitials = (firstName, lastName) => {
    const first = firstName ? firstName.charAt(0).toUpperCase() : "";
    const last = lastName ? lastName.charAt(0).toUpperCase() : "";
    return first + last || "?";
  };

  const getAvatarUrl = (user_image_url) => {
    if (!user_image_url || user_image_url === "") return null;
    return `${process.env.REACT_APP_USER_IMAGE_BASE_URL}${user_image_url}`;
  };

  return (
    <>
      <div
        onClick={() => props.toggleAccordionForEmployeeUnRead()}
        className={
          props.accordionOnForEmployeeUnRead
            ? `${styles.accordionOn} ${styles.Open}`
            : `${styles.accordionOn}`
        }
      >
        <p className={`${styles.ListAccoudionTitle}`}>
          <ChevronDown /> Employees <span>{unreadMessageCounter}</span>
        </p>

        <div>
          {employeeUnreadMessages.length > 0 &&
            employeeUnreadMessages.map((employee, i) => {
              return (
                <div
                  key={i}
                  className={
                    employee.id === props?.prospectTenantDetails?.id &&
                    props?.prospectTenantDetails?.type === "Employee"
                      ? `${styles.activeTenant} ${styles.CommuListSec}`
                      : `${styles.CommuListSec}`
                  }
                  onClick={(e) => {
                    e.stopPropagation();
                    props.setDetails(employee);
                  }}
                >
                  <div className={`${styles.EmployeeListDeSec}`}>
                    <div className={`${styles.EmployeeAvatarSec}`}>
                      {getAvatarUrl(employee?.user_image_url) ? (
                        <img
                          src={getAvatarUrl(employee.user_image_url)}
                          alt=""
                          className={`${styles.EmpAvatarImg}`}
                        />
                      ) : (
                        <p className={`${styles.EmpAvatarInitials}`}>
                          {getInitials(employee.first_name, employee.last_name)}
                        </p>
                      )}
                      {employee?.is_online === 1 && (
                        <span
                          className={`${styles.StatusBadge} ${styles.Online}`}
                        ></span>
                      )}
                      {employee?.is_online !== 1 && (
                        <span className={`${styles.StatusBadge}`}></span>
                      )}
                    </div>
                    <div>
                      <p className={`${styles.ProsTenantList}`}>
                        {employee?.first_name ? (
                          <span>
                            {employee?.first_name}&nbsp;{employee?.last_name}
                          </span>
                        ) : (
                          <span>{formatPhoneNumber(employee?.phone)}</span>
                        )}
                      </p>
                      <p className={`${styles.ProsTenantListDe}`}>
                        <span>{employee?.role}</span>
                      </p>
                    </div>
                  </div>
                  <div className={`${styles.CommuListStatusSec}`}>
                    {employee?.message && (
                      <p className={`${styles.UnreadMessageTime}`}>
                        {moment(employee?.message_time).fromNow()}
                      </p>
                    )}
                    {employee?.unread_no > 0 && (
                      <p className={`${styles.UnreadProfileCounter}`}>
                        {employee?.unread_no}
                      </p>
                    )}
                  </div>

                  <div className={`${styles.UnreadInfoSec} ${styles.PaddLeft}`}>
                    {employee?.message && (
                      <div className={`${styles.UnreadMsgSec}`}>
                        <p
                          className={
                            employee?.unread_no > 0 &&
                            !employee?.message.startsWith("You:")
                              ? `${styles.UnreadMessage} ${styles.Unread}`
                              : `${styles.UnreadMessage}`
                          }
                        >
                          {employee?.message}
                        </p>
                      </div>
                    )}

                    {!employee?.message && (
                      <div className={`${styles.UnreadMsgSec}`}>
                        <p className={`${styles.CommounMsg}`}>--</p>
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
        </div>

        {employeeUnreadMessages.length === 0 && (
          <div className={`${styles.NoDataSecOnlyText}`}>
            <img src="/static/img/chatIcon.png" alt="" />
            <p>No employee here!</p>
          </div>
        )}
      </div>
    </>
  );
};

export default EmployeeListunread;
